module.exports = __webpack_public_path__ + "static/img/login-banner.4356db55.png";